export const homeSelectDetails = {
  ConstructionStyle: {
    Apartment: {
      item_thumbnail: '',
      item_description: '',
    },
    Backsplit: {
      item_thumbnail: '',
      item_description: '',
    },
    BiLevel: {
      item_thumbnail: '',
      item_description: '',
    },
    BiLevelRowCenter: {
      item_thumbnail: '',
      item_description: '',
    },
    BiLevelRowEnd: {
      item_thumbnail: '',
      item_description: '',
    },
    Bungalow: {
      item_thumbnail: '',
      item_description: '',
    },
    CapeCod: {
      item_thumbnail: '',
      item_description: '',
    },
    Colonial: {
      item_thumbnail: '',
      item_description: '',
    },
    Contemporary: {
      item_thumbnail: '',
      item_description: '',
    },
    Cottage: {
      item_thumbnail: '',
      item_description: '',
    },
    CoOp: {
      item_thumbnail: '',
      item_description: '',
    },
    FederalColonial: {
      item_thumbnail: '',
      item_description: '',
    },
    Mediterranean: {
      item_thumbnail: '',
      item_description: '',
    },
    OrnateVictorian: {
      item_thumbnail: '',
      item_description: '',
    },
    QueenAnne: {
      item_thumbnail: '',
      item_description: '',
    },
    RaisedRanch: {
      item_thumbnail: '',
      item_description: '',
    },
    Rambler: {
      item_thumbnail: '',
      item_description: '',
    },
    Ranch: {
      item_thumbnail: '',
      item_description: '',
    },
    Rowhouse: {
      item_thumbnail: '',
      item_description: '',
    },
    RowhouseCenter: {
      item_thumbnail: '',
      item_description: '',
    },
    RowhouseEnd: {
      item_thumbnail: '',
      item_description: '',
    },
    SouthwestAdobe: {
      item_thumbnail: '',
      item_description: '',
    },
    SplitFoyer: {
      item_thumbnail: '',
      item_description: '',
    },
    SplitLevel: {
      item_thumbnail: '',
      item_description: '',
    },
    SubStandard: {
      item_thumbnail: '',
      item_description: '',
    },
    Townhouse: {
      item_thumbnail: '',
      item_description: '',
    },
    TownhouseCenter: {
      item_thumbnail: '',
      item_description: '',
    },
    TownhouseEnd: {
      item_thumbnail: '',
      item_description: '',
    },
    TriLevel: {
      item_thumbnail: '',
      item_description: '',
    },
    TriLevelCenter: {
      item_thumbnail: '',
      item_description: '',
    },
    Victorian: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  ExteriorWalls: {
    Adobe: {
      item_thumbnail: '',
      item_description: '',
    },
    Brick: {
      item_thumbnail: '',
      item_description: '',
    },
    BrickBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    BrickBlockCustom: {
      item_thumbnail: '',
      item_description: '',
    },
    BrickVeneer: {
      item_thumbnail: '',
      item_description: '',
    },
    Clapboard: {
      item_thumbnail: '',
      item_description: '',
    },
    ConcreteBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    EIFS: {
      item_thumbnail: '',
      item_description: '',
    },
    Frame: {
      item_thumbnail: '',
      item_description: '',
    },
    HardyBoard: {
      item_thumbnail: '',
      item_description: '',
    },
    Logs: {
      item_thumbnail: '',
      item_description: '',
    },
    PouredConcrete: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingAluminum: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingHardboard: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingPlywood: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingSteel: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingT111: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingVinyl: {
      item_thumbnail: '',
      item_description: '',
    },
    SidingWood: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidBrick: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidBrickCustom: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidBrownstone: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidStone: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidStoneCustom: {
      item_thumbnail: '',
      item_description: '',
    },
    StoneonBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    StoneonBlockCustomStone: {
      item_thumbnail: '',
      item_description: '',
    },
    StoneVeneer: {
      item_thumbnail: '',
      item_description: '',
    },
    StoneVeneerCustom: {
      item_thumbnail: '',
      item_description: '',
    },
    Stucco: {
      item_thumbnail: '',
      item_description: '',
    },
    StuccoonBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    StuccoonFrame: {
      item_thumbnail: '',
      item_description: '',
    },
    VictorianScallopedShakes: {
      item_thumbnail: '',
      item_description: '',
    },
    WindowWall: {
      item_thumbnail: '',
      item_description: '',
    },
    WoodShakes: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  RoofShape: {
    Flat: {
      item_thumbnail: 'roof-flat.jpg',
      item_description: 'Flat roofs do not have a pitch or slope and are usually found in low precipitation regions.',
    },
    Gable: {
      item_thumbnail: 'roof-gable.jpg',
      item_description: 'Gable roofs consists of two angled sides that come together in the shape of an inverted V.',
    },
    Gambrel: {
      item_thumbnail: 'roof-gambrel.jpg',
      item_description: 'Gambrel roofs are made up of two different slope angles that creates a symmetrical shape. The top slope usually has a more shallow angle than the bottom slope.',
    },
    Hip: {
      item_thumbnail: 'roof-hip.jpg',
      item_description: 'Hip roofs have sloped angles on all sides of the structure. The slope angles can consist of multiple steep or gradual pitches.',
    },
    Mansard: {
      item_thumbnail: 'roof-mansard.jpg',
      item_description: 'A mansard roof is a variation of the hip and gambrel style roofs. The top slope comes together at a ridge while the bottom slope is usually at a steeper angle and can consist of dormer windows. Mansard roofs are commonly referred to as a "French or curb" roof.',
    },
    Other: {
      item_thumbnail: '',
      item_description: 'All other roofs that does not fall under any of the above shapes.',
    },
  },
  RoofPitchType: {
    Flat: {
      item_thumbnail: '',
      item_description: '',
    },
    Moderate: {
      item_thumbnail: '',
      item_description: '',
    },
    Slight: {
      item_thumbnail: '',
      item_description: '',
    },
    Steep: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  RoofMaterial: {
    ArchitecturalShingles: {
      item_thumbnail: '',
      item_description: '',
    },
    Asbestos: {
      item_thumbnail: '',
      item_description: '',
    },
    AsphaltShingles: {
      item_thumbnail: '',
      item_description: '',
    },
    Composition: {
      item_thumbnail: '',
      item_description: '',
    },
    CopperFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    CopperPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    CorrugatedSteelFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    CorrugatedSteelPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    Fiberglass: {
      item_thumbnail: '',
      item_description: '',
    },
    Foam: {
      item_thumbnail: '',
      item_description: '',
    },
    MetalFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    MetalPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    MineralFiberShake: {
      item_thumbnail: '',
      item_description: '',
    },
    PlasticFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    PlasticPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    RolledPaperFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    RolledPaperPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    RubberFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    RubberPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    Slate: {
      item_thumbnail: '',
      item_description: '',
    },
    Tar: {
      item_thumbnail: '',
      item_description: '',
    },
    TarGravel: {
      item_thumbnail: '',
      item_description: '',
    },
    TileClay: {
      item_thumbnail: '',
      item_description: '',
    },
    TileConcrete: {
      item_thumbnail: '',
      item_description: '',
    },
    TileSpanish: {
      item_thumbnail: '',
      item_description: '',
    },
    TinFlat: {
      item_thumbnail: '',
      item_description: '',
    },
    TinPitched: {
      item_thumbnail: '',
      item_description: '',
    },
    WoodFiberglassShingles: {
      item_thumbnail: '',
      item_description: '',
    },
    WoodShake: {
      item_thumbnail: '',
      item_description: '',
    },
    WoodShingles: {
      item_thumbnail: '',
      item_description: '',
    },
    Other: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  GarageType: {
    None: {
      item_thumbnail: '',
      item_description: '',
    },
    Carport: {
      item_thumbnail: '',
      item_description: '',
    },
    GarageAttached: {
      item_thumbnail: '',
      item_description: '',
    },
    GarageBasement: {
      item_thumbnail: '',
      item_description: '',
    },
    GarageBuiltIn: {
      item_thumbnail: '',
      item_description: '',
    },
    GarageDetached: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  WallMaterial: {
    Adobe: {
      item_thumbnail: '',
      item_description: '',
    },
    Block: {
      item_thumbnail: '',
      item_description: '',
    },
    BrickBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    Drywall: {
      item_thumbnail: '',
      item_description: '',
    },
    DrywallTextured: {
      item_thumbnail: '',
      item_description: '',
    },
    GlassBlock: {
      item_thumbnail: '',
      item_description: '',
    },
    Plaster: {
      item_thumbnail: '',
      item_description: '',
    },
    PlasterHorsehair: {
      item_thumbnail: '',
      item_description: '',
    },
    PlasterTextured: {
      item_thumbnail: '',
      item_description: '',
    },
    PlywoodOnly: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidBrick: {
      item_thumbnail: '',
      item_description: '',
    },
    SolidStone: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  WallFinishMaterial: {
    Brick: {
      item_thumbnail: '',
      item_description: '',
    },
    CabinetryBuiltIn: {
      item_thumbnail: '',
      item_description: '',
    },
    Carpet: {
      item_thumbnail: '',
      item_description: '',
    },
    Millwork: {
      item_thumbnail: '',
      item_description: '',
    },
    Mirrors: {
      item_thumbnail: '',
      item_description: '',
    },
    Paint: {
      item_thumbnail: '',
      item_description: '',
    },
    PanelingKnottyPine: {
      item_thumbnail: '',
      item_description: '',
    },
    PanelingSheet: {
      item_thumbnail: '',
      item_description: '',
    },
    PanelingSolidWood: {
      item_thumbnail: '',
      item_description: '',
    },
    PanelingTongueGroove: {
      item_thumbnail: '',
      item_description: '',
    },
    SpongeCoat: {
      item_thumbnail: '',
      item_description: '',
    },
    Stone: {
      item_thumbnail: '',
      item_description: '',
    },
    Terrazzo: {
      item_thumbnail: '',
      item_description: '',
    },
    TileCeramic: {
      item_thumbnail: '',
      item_description: '',
    },
    TileCeramicImported: {
      item_thumbnail: '',
      item_description: '',
    },
    TileMarble: {
      item_thumbnail: '',
      item_description: '',
    },
    WallpaperFoil: {
      item_thumbnail: '',
      item_description: '',
    },
    WallpaperGrassCloth: {
      item_thumbnail: '',
      item_description: '',
    },
    WallpaperVinyl: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  CeilingMaterial: {
    Drywall: {
      item_thumbnail: '',
      item_description: '',
    },
    DrywallTextured: {
      item_thumbnail: '',
      item_description: '',
    },
    Marble: {
      item_thumbnail: '',
      item_description: '',
    },
    Metal: {
      item_thumbnail: '',
      item_description: '',
    },
    Millwork: {
      item_thumbnail: '',
      item_description: '',
    },
    Mirrors: {
      item_thumbnail: '',
      item_description: '',
    },
    Plaster: {
      item_thumbnail: '',
      item_description: '',
    },
    PlasterTextured: {
      item_thumbnail: '',
      item_description: '',
    },
    RecessedLighting: {
      item_thumbnail: '',
      item_description: '',
    },
    TileAcoustical: {
      item_thumbnail: '',
      item_description: '',
    },
    Tin: {
      item_thumbnail: '',
      item_description: '',
    },
    TongueGrove: {
      item_thumbnail: '',
      item_description: '',
    },
    Wood: {
      item_thumbnail: '',
      item_description: '',
    },
  },
  FloorMaterial: {
    Brick: {
      item_thumbnail: 'floor-brick.png',
      item_description: 'A floor’s surface is made up of individual bricks and usually held together by mortar or grouting.',
    },
    CarpetAcrylicNylon: {
      item_thumbnail: 'floor-carpet-acrylic.png',
      item_description: 'Acrylic and nylon carpets are the most common carpet materials.',
    },
    CarpetWoolBerber: {
      item_thumbnail: 'floor-carpet-berber.png',
      item_description: 'Wool and berber carpets are considered more luxurious because of the material costs.',
    },
    CarpetOverHardwoodAcrylicNylon: {
      item_thumbnail: 'floor-carpet-wood-acrylic.png',
      item_description: 'Acrylic and nylon carpets installed on top of hardwood floors.',
    },
    CarpetOverHardwoodWoolBerber: {
      item_thumbnail: 'floor-carpet-wood-berber.png',
      item_description: 'Wool and berber carpets installed on top of hardwood floors.',
    },
    ConcreteStampedTextured: {
      item_thumbnail: 'floor-concrete.png',
      item_description: 'A basic flooring option where a concrete slab is polished stamped or texturized.',
    },
    Flagstone: {
      item_thumbnail: 'floor-flagstone.png',
      item_description: 'Natural flooring made up of large flat pieces of quarried stone.',
    },
    Granite: {
      item_thumbnail: 'floor-granite.png',
      item_description: 'Natural flooring made up of granite slabs or tiles.',
    },
    Hardwood: {
      item_thumbnail: 'floor-hardwood.png',
      item_description: 'Common flooring made of single planks of timber.',
    },
    LaminatedWoodFlooring: {
      item_thumbnail: 'floor-laminated-wood.png',
      item_description: 'Also known as a "floating wood floor," this is a common synthetic flooring that mimics a hardwood floor.',
    },
    Parquet: {
      item_thumbnail: 'floor-parquet.png',
      item_description: 'A wooden tile flooring that are laid out to create geometric patterns.',
    },
    Plank: {
      item_thumbnail: 'floor-plank.png',
      item_description: 'Long strips made up of wood or synthetic materials laid out in rows.',
    },
    Rubber: {
      item_thumbnail: 'floor-rubber.png',
      item_description: 'Rubber tiles, mats and other products used for permanent and temporary installations.',
    },
    Slate: {
      item_thumbnail: 'floor-slate.png',
      item_description: 'Natural flooring made up of quarried slate tiles.',
    },
    Stone: {
      item_thumbnail: 'floor-stone.png',
      item_description: 'Natural flooring made up of quarried stone. Stone floors can be rough cut or in the form of tiles and slabs.',
    },
    TileCeramic: {
      item_thumbnail: 'floor-tile-ceramic.png',
      item_description: 'Natural tile made up of sand, clays and other natural materials.',
    },
    TileCeramicImported: {
      item_thumbnail: 'floor-tile-ceramic-imported.png',
      item_description: 'High-quality tile made up of exotic sand, clays and other natural materials.',
    },
    TileMarble: {
      item_thumbnail: 'floor-tile-marble.png',
      item_description: 'High-end tiles made up of polished marble.',
    },
    TileTerrazzo: {
      item_thumbnail: 'floor-tile-terrazzo.png',
      item_description: 'Tiles created by combining concrete and exposed marble chips. They are then polished until the tiles are smooth.',
    },
    Vinyl: {
      item_thumbnail: 'floor-vinyl.png',
      item_description: 'A highly durable flooring option that is made from synthetic materials, and designed to look like wood.',
    },
  },
  KitchenType: {
    Basic: {
      item_thumbnail: 'kitchen-basic.jpg',
      item_description: 'Consists of the minimum building code requirements and the lowest quality materials, fixtures and appliances.',
    },
    BuildersGrade: {
      item_thumbnail: 'kitchen-builders.jpg',
      item_description: 'Consists of the medium-grade materials, fixtures and appliances. This is the most common kitchen type.',
    },
    Custom: {
      item_thumbnail: 'kitchen-custom.jpg',
      item_description: 'Consists of the custom and high-quality materials, fixtures and appliances. Custom features significantly cost more and usually requires some craftsmanship',
    },
    SemiCustom: {
      item_thumbnail: 'kitchen-semicustom.jpg',
      item_description: 'Partially consists of higher-grade materials, fixtures and appliances when compared to the builder’s grade. Materials and fixtures may have a semi-custom features.',
    },
    Designer: {
      item_thumbnail: 'kitchen-designer.jpg',
      item_description: 'Consists of custom, luxury and brand name materials, fixtures and appliances. Materials and fixtures are of the highest quality money can buy.',
    },
  },
  BathroomType: {
    Basic: {
      item_thumbnail: 'bathroom-basic.jpg',
      item_description: 'Consists of the minimum building code requirements and the lowest quality materials, fixtures and appliances.',
    },
    BuildersGrade: {
      item_thumbnail: 'bathroom-builders.jpg',
      item_description: 'Consists of the medium-grade materials, fixtures and appliances. This is the most common kitchen type.',
    },
    Custom: {
      item_thumbnail: 'bathroom-custom.jpg',
      item_description: 'Consists of the custom and high-quality materials, fixtures and appliances. Custom features significantly cost more and usually requires some craftsmanship',
    },
    SemiCustom: {
      item_thumbnail: 'bathroom-semicustom.jpg',
      item_description: 'Partially consists of higher-grade materials, fixtures and appliances when compared to the builder’s grade. Materials and fixtures may have a semi-custom features.',
    },
    Designer: {
      item_thumbnail: 'bathroom-designer.jpg',
      item_description: 'Consists of custom, luxury and brand name materials, fixtures and appliances. Materials and fixtures are of the highest quality money can buy.',
    },
  },
};

export const condoSelectDetails = {
  FloorMaterial: {
    Brick: {
      item_thumbnail: 'floor-brick.png',
      item_description: 'A floor’s surface is made up of individual bricks and usually held together by mortar or grouting.',
    },
    CarpetAcrylicNylon: {
      item_thumbnail: 'floor-carpet-acrylic.png',
      item_description: 'Acrylic and nylon carpets are the most common carpet materials.',
    },
    CarpetWoolBerber: {
      item_thumbnail: 'floor-carpet-berber.png',
      item_description: 'Wool and berber carpets are considered more luxurious because of the material costs.',
    },
    CarpetOverHardwoodAcrylicNylon: {
      item_thumbnail: 'floor-carpet-wood-acrylic.png',
      item_description: 'Acrylic and nylon carpets installed on top of hardwood floors.',
    },
    CarpetOverHardwoodWoolBerber: {
      item_thumbnail: 'floor-carpet-wood-berber.png',
      item_description: 'Wool and berber carpets installed on top of hardwood floors.',
    },
    ConcreteStampedTextured: {
      item_thumbnail: 'floor-concrete.png',
      item_description: 'A basic flooring option where a concrete slab is polished stamped or texturized.',
    },
    Flagstone: {
      item_thumbnail: 'floor-flagstone.png',
      item_description: 'Natural flooring made up of large flat pieces of quarried stone.',
    },
    Granite: {
      item_thumbnail: 'floor-granite.png',
      item_description: 'Natural flooring made up of granite slabs or tiles.',
    },
    Hardwood: {
      item_thumbnail: 'floor-hardwood.png',
      item_description: 'Common flooring made of single planks of timber.',
    },
    LaminatedWoodFlooring: {
      item_thumbnail: 'floor-laminated-wood.png',
      item_description: 'Also known as a "floating wood floor," this is a common synthetic flooring that mimics a hardwood floor.',
    },
    Parquet: {
      item_thumbnail: 'floor-parquet.png',
      item_description: 'A wooden tile flooring that are laid out to create geometric patterns.',
    },
    Plank: {
      item_thumbnail: 'floor-plank.png',
      item_description: 'Long strips made up of wood or synthetic materials laid out in rows.',
    },
    Rubber: {
      item_thumbnail: 'floor-rubber.png',
      item_description: 'Rubber tiles, mats and other products used for permanent and temporary installations.',
    },
    Slate: {
      item_thumbnail: 'floor-slate.png',
      item_description: 'Natural flooring made up of quarried slate tiles.',
    },
    Stone: {
      item_thumbnail: 'floor-stone.png',
      item_description: 'Natural flooring made up of quarried stone. Stone floors can be rough cut or in the form of tiles and slabs.',
    },
    TileCeramic: {
      item_thumbnail: 'floor-tile-ceramic.png',
      item_description: 'Natural tile made up of sand, clays and other natural materials.',
    },
    TileCeramicImported: {
      item_thumbnail: 'floor-tile-ceramic-imported.png',
      item_description: 'High-quality tile made up of exotic sand, clays and other natural materials.',
    },
    TileMarble: {
      item_thumbnail: 'floor-tile-marble.png',
      item_description: 'High-end tiles made up of polished marble.',
    },
    TileTerrazzo: {
      item_thumbnail: 'floor-tile-terrazzo.png',
      item_description: 'Tiles created by combining concrete and exposed marble chips. They are then polished until the tiles are smooth.',
    },
    Vinyl: {
      item_thumbnail: 'floor-vinyl.png',
      item_description: 'A highly durable flooring option that is made from synthetic materials, and designed to look like wood.',
    },
  },
  KitchenType: {
    Basic: {
      item_thumbnail: 'kitchen-basic.jpg',
      item_description: 'Consists of the minimum building code requirements and the lowest quality materials, fixtures and appliances.',
    },
    BuildersGrade: {
      item_thumbnail: 'kitchen-builders.jpg',
      item_description: 'Consists of the medium-grade materials, fixtures and appliances. This is the most common kitchen type.',
    },
    Custom: {
      item_thumbnail: 'kitchen-custom.jpg',
      item_description: 'Consists of the custom and high-quality materials, fixtures and appliances. Custom features significantly cost more and usually requires some craftsmanship',
    },
    SemiCustom: {
      item_thumbnail: 'kitchen-semicustom.jpg',
      item_description: 'Partially consists of higher-grade materials, fixtures and appliances when compared to the builder’s grade. Materials and fixtures may have a semi-custom features.',
    },
    Designer: {
      item_thumbnail: 'kitchen-designer.jpg',
      item_description: 'Consists of custom, luxury and brand name materials, fixtures and appliances. Materials and fixtures are of the highest quality money can buy.',
    },
  },
  BathroomType: {
    Basic: {
      item_thumbnail: 'bathroom-basic.jpg',
      item_description: 'Consists of the minimum building code requirements and the lowest quality materials, fixtures and appliances.',
    },
    BuildersGrade: {
      item_thumbnail: 'bathroom-builders.jpg',
      item_description: 'Consists of the medium-grade materials, fixtures and appliances. This is the most common kitchen type.',
    },
    Custom: {
      item_thumbnail: 'bathroom-custom.jpg',
      item_description: 'Consists of the custom and high-quality materials, fixtures and appliances. Custom features significantly cost more and usually requires some craftsmanship',
    },
    SemiCustom: {
      item_thumbnail: 'bathroom-semicustom.jpg',
      item_description: 'Partially consists of higher-grade materials, fixtures and appliances when compared to the builder’s grade. Materials and fixtures may have a semi-custom features.',
    },
    Designer: {
      item_thumbnail: 'bathroom-designer.jpg',
      item_description: 'Consists of custom, luxury and brand name materials, fixtures and appliances. Materials and fixtures are of the highest quality money can buy.',
    },
  },
  RoofShape: {
    Flat: {
      item_thumbnail: 'roof-flat.jpg',
      item_description: 'Flat roofs do not have a pitch or slope and are usually found in low precipitation regions.',
    },
    Gable: {
      item_thumbnail: 'roof-gable.jpg',
      item_description: 'Gable roofs consists of two angled sides that come together in the shape of an inverted V.',
    },
    Gambrel: {
      item_thumbnail: 'roof-gambrel.jpg',
      item_description: 'Gambrel roofs are made up of two different slope angles that creates a symmetrical shape. The top slope usually has a more shallow angle than the bottom slope.',
    },
    Hip: {
      item_thumbnail: 'roof-hip.jpg',
      item_description: 'Hip roofs have sloped angles on all sides of the structure. The slope angles can consist of multiple steep or gradual pitches.',
    },
    Mansard: {
      item_thumbnail: 'roof-mansard.jpg',
      item_description: 'A mansard roof is a variation of the hip and gambrel style roofs. The top slope comes together at a ridge while the bottom slope is usually at a steeper angle and can consist of dormer windows. Mansard roofs are commonly referred to as a "French or curb" roof.',
    },
    Other: {
      item_thumbnail: '',
      item_description: 'All other roofs that does not fall under any of the above shapes.',
    },
  },
};

export const rentersSelectDetails = {
  RoofShape: {
    Flat: {
      item_thumbnail: 'roof-flat.jpg',
      item_description: 'Flat roofs do not have a pitch or slope and are usually found in low precipitation regions.',
    },
    Gable: {
      item_thumbnail: 'roof-gable.jpg',
      item_description: 'Gable roofs consists of two angled sides that come together in the shape of an inverted V.',
    },
    Gambrel: {
      item_thumbnail: 'roof-gambrel.jpg',
      item_description: 'Gambrel roofs are made up of two different slope angles that creates a symmetrical shape. The top slope usually has a more shallow angle than the bottom slope.',
    },
    Hip: {
      item_thumbnail: 'roof-hip.jpg',
      item_description: 'Hip roofs have sloped angles on all sides of the structure. The slope angles can consist of multiple steep or gradual pitches.',
    },
    Mansard: {
      item_thumbnail: 'roof-mansard.jpg',
      item_description: 'A mansard roof is a variation of the hip and gambrel style roofs. The top slope comes together at a ridge while the bottom slope is usually at a steeper angle and can consist of dormer windows. Mansard roofs are commonly referred to as a "French or curb" roof.',
    },
    Other: {
      item_thumbnail: '',
      item_description: 'All other roofs that does not fall under any of the above shapes.',
    },
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/dictionaries/select-images-details.js
// module id = null
// module chunks = 